import service from '@/store/services/invoices/invoices-service';

const state = {
    list: {},
    invoice: {},
    meta: {},
    url: null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, invoice) => {
        state.invoice = invoice;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then((invoice) => {
                commit('SET_RESOURCE', invoice);
            });
    },
    execute ({ commit, dispatch }, params) {
        return service.execute(params)
            .then((invoice) => {
                commit('SET_RESOURCE', invoice);
            });
    },

    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((invoice) => {
                commit('SET_RESOURCE', invoice);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((invoice) => {
                commit('SET_RESOURCE', invoice);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    update1 ({ commit, dispatch }, params) {
        return service.update1(params)
            .then((invoice) => {
                commit('SET_RESOURCE', invoice);
            });
    },
    downloadPdf({ dispatch}, { id, preview = false }) {
        return service.downloadPdf(id, preview);
    } ,
    downloadPdfStatus({dispatch}, { id }) {
        return service.downloadPdfStatus(id);
    },
    generatePdf({dispatch}, { id }) {
        return service.generatePdf(id);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    invoice: state => state.invoice,
    dropdown: (state) => {
        return state.list.map(invoice => ({
            id: invoice.id,
            invoice_number: invoice.invoice_number
        }));
    },
    url: state => state.url
};

const invoices = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default invoices;
